import { booleanAttribute, Component, HostBinding, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

/**
 * @deprecated Use Material's native `[showProgress]` input with `GlxyButtonShowProgress`
 * from `@vendasta/galaxy/button-show-progress` instead.
 */
@Component({
  selector: 'glxy-button-loading-indicator',
  templateUrl: './button-loading-indicator.component.html',
  styleUrls: ['./button-loading-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatProgressSpinnerModule],
})
export class ButtonLoadingIndicatorComponent {
  @HostBinding('class') class = 'glxy-button-loading-indicator';

  // isLoading cannot yet be an input signal, because libs/reports/dynamic/src/lib/services/report-loader.service.ts sets it directly.
  // The report-loader service should be refactored to properly support reactive behaviour.
  @HostBinding('class.is-loading')
  @Input({ transform: booleanAttribute })
  isLoading = false;
}
